export default function SafetySection() {
  const checks = [
    { item: 'Website Verification', recommendation: 'Always check official sources' },
    { item: 'Payment Safety', recommendation: 'Use secure payment methods' },
    { item: 'Product Review', recommendation: 'Check QC photos carefully' },
    { item: 'Link Safety', recommendation: 'Avoid suspicious redirects' },
    { item: 'Personal Data', recommendation: 'Protect account information' },
  ];

  return (
    <section id="safety" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-3">
          Is Vigorbuy Spreadsheet Safe?
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center mb-10 max-w-xl mx-auto">
          Your safety is important. Here is a checklist to ensure you have a secure experience when using the Vigorbuy Spreadsheet.
        </p>

        <div className="bg-background-50 rounded-lg border border-background-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800">Security Check</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-700">Recommendation</th>
              </tr>
            </thead>
            <tbody>
              {checks.map((check, i) => (
                <tr key={check.item} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="px-5 py-3 text-foreground-800 font-medium">
                    <span className="flex items-center gap-2">
                      <i className="ri-shield-check-line text-accent-500 text-base"></i>
                      {check.item}
                    </span>
                  </td>
                  <td className="px-5 py-3 text-foreground-600">{check.recommendation}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs md:text-sm text-foreground-500 leading-relaxed max-w-lg mx-auto">
            <strong className="text-foreground-700">Important:</strong> The Vigorbuy Spreadsheet is an independent educational resource. We recommend always verifying products and sellers before making purchases. Use official payment channels and protect your personal information at all times.
          </p>
        </div>
      </div>
    </section>
  );
}